import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          {aboutData.title}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          致力于打造纯净、高效的免费看片平台
        </p>

        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="flex-1 space-y-4">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-4">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center bg-background-50 rounded-lg py-4 px-3">
                  <p className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 w-full max-w-md">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src={aboutData.imageUrl}
                alt="关于91免费看片平台"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}